<mat-card
  appearance="outlined"
  class="split listCell"
  [ngClass]="isSelected ? 'selected' : ''"
  (click)="cardClick(data)"
>
  <!-- SELELECTED CHECK ICON -->
  <div *ngIf="isSelected" class="selected-check-container">
    <div class="selected-check">
      <mat-icon *ngIf="isSelected">done</mat-icon>
    </div>
  </div>

  <!-- LEFT SIDE CONTENT -->
  <div class="left">
    <div class="hstack" style="justify-content: space-between">
      <div class="vstack" style="margin-bottom: 8px; width: 100%">
        <h3>PALLETIZING PATTERN</h3>
        <h1>{{ fullDetailList[cardDetailsData[0].key] }}</h1>

        <div *ngIf="fullDetailList['updated_at']" class="hstack">
          <h3 class="tagline">Last edited</h3>
          <h3 class="tagline" style="color: #070a17">
            {{
              timeUtils.getFormattedDate(
                fullDetailList['updated_at'],
                'time-since'
              ) + ' ago'
            }}
          </h3>
        </div>

        <div [@expandDetails]="detailsCollapsed">
          <div style="overflow-y: hidden; margin: 15px 0px">
            <div *ngFor="let detail of cardDetailsData; let i = index">
              <div *ngIf="i !== 0" class="keyvalPair">
                <p class="spaced-wrapper keyvalPair">
                  <span class="key">{{ detail.name }}</span>
                  <span class="val">{{ fullDetailList[detail.key] }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="expand-details mat-focus-indicator mat-button mat-button-base mat-primary"
          (click)="onDetailsExpandClick(); $event.stopPropagation()"
        >
          <button
            mat-icon-button
            class="expand-button-vertical"
            title="{{
              detailsCollapsed
                ? 'Click to expand more details'
                : 'Click to hide details'
            }}"
          >
            <mat-icon mat-icon-button>
              {{ detailsCollapsed ? 'expand_more' : 'expand_less' }}
            </mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- RIGHT SIDE GRAPHICS -->
  <div class="card-left">
    <div class="card-product-view corner-rounded-left">
      <app-lite-pattern-view
        class="corner-rounded-left"
        [project]="project"
        [sticker]="(logoService.eitherLabelOrLogo$ | async)?.texture"
        [interactive]="interactive"
      ></app-lite-pattern-view>
    </div>

    <div class="card-pattern-view corner-rounded-right">
      <app-new-product-view
        class="corner-rounded-right"
        style="width: 100%; height: 100%"
        [length]="data.pattern.data.productDimensions.length"
        [width]="data.pattern.data.productDimensions.width"
        [height]="data.pattern.data.productDimensions.height"
        [sticker]="(logoService.eitherLabelOrLogo$ | async)?.texture"
        [labelOrientations]="[data.pattern.data.labelOrientation]"
      ></app-new-product-view>
    </div>
  </div>
</mat-card>
